var User = /** @class */ (function () {
    function User(props) {
        Object.assign(this, props);
        if (!(props === null || props === void 0 ? void 0 : props.language))
            this.language = 'en';
    }
    Object.defineProperty(User.prototype, "isProfessional", {
        get: function () {
            return this.profile === ClientProfile.Professional;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "isRetail", {
        get: function () {
            return this.profile === ClientProfile.Retail;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "isAdministrator", {
        get: function () {
            return this.role === Role.Administrator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "isSupervisor", {
        get: function () {
            return this.role === Role.Supervisor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "isSeller", {
        get: function () {
            return this.role === Role.Seller;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "isVirtual", {
        get: function () {
            return this.role === Role.Virtual;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "isCollaborator", {
        get: function () {
            return this.subProfile === Subprofile.Collaborator || this.subProfile === Subprofile.OperatorCollaborator || false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "isSupport", {
        get: function () {
            return this.role === Role.Support || this.username === 'Soporte';
        },
        enumerable: false,
        configurable: true
    });
    return User;
}());
export { User };
export var Role = {
    Administrator: 'administrator',
    Supervisor: 'supervisor',
    Seller: 'seller',
    Support: 'support',
    Virtual: 'virtual',
};
export var ClientProfile = {
    Hostelry: 'hostelry',
    Professional: 'professional',
    Retail: 'retail',
    Ticket: 'ticket'
};
export var Subprofile = {
    BarRestaurant: 'barRestaurant',
    TakeAway: 'takeAway',
    Law: 'law',
    Consultant: 'consultant',
    Installer: 'installer',
    Doctor: 'doctor',
    Veterinary: 'veterinary',
    Beauty: 'beauty',
    Fashion: 'fashion',
    Technology: 'technology',
    Operator: 'operator',
    Collaborator: 'collaborator',
    OperatorCollaborator: 'operator_collaborator',
    Other: 'other'
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/Users/Model.ts
// module id = 110
// module chunks = 0